import { useState } from "react"
import { Mail } from "lucide-react"

import { cn } from "@/lib/utils"
import type { QuizStep } from "../../types"

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

interface EmailStepProps {
  step: QuizStep
  value: string
  onChange: (value: string) => void
}

export function EmailStep({ step, value, onChange }: EmailStepProps) {
  const [touched, setTouched] = useState(false)
  const showError = touched && value.length > 0 && !EMAIL_RE.test(value)

  return (
    <div className="space-y-2">
      <div
        className={cn(
          "flex h-12 items-center gap-2 rounded-xl bg-purple-light/10 px-3 transition-colors",
          showError && "ring-1 ring-peach",
        )}
      >
        <Mail
          className={cn("size-5 shrink-0", showError ? "text-peach" : "text-purple-light/50")}
        />
        <input
          type="email"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={() => setTouched(true)}
          placeholder={step.placeholder || "Enter your email"}
          className="h-full flex-1 bg-transparent text-base font-medium text-purple-light outline-none placeholder:text-purple-light/40"
          autoFocus
        />
      </div>
      {showError && <p className="text-sm text-peach">Please enter a valid email</p>}
    </div>
  )
}
